const getStateUI = (state) => state?.ui?.ui;

const isLoading = (state) => getStateUI(state)?.loading;

const uiSelectors = { isLoading };

export default uiSelectors;